import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class TiposRacaService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
  
      this.url = env.baseDp + "tipos-raca";
      
      this.controladoresDeInstancia = {
        listar: new AbortController()
      }
    }
  
    async listar(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      const queryString = this.converterObjetoDeFiltrosParaQueryString(objetoDeFiltros);
      return super.get(`${this.url}` + queryString, this.controladoresDeInstancia.listar);
    }
  }

  export const tiposRacaService = new TiposRacaService()
  